<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-bed`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 5a2 2 0 012 2v16h1a2 2 0 012 2v13a2 2 0 01-2 2h-3v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4H11v4a1 1 0 01-1 1H8a1 1 0 01-1-1v-4H4a2 2 0 01-2-2V25a2 2 0 012-2h1V7a2 2 0 012-2h34zm1 22H6v9h36v-9zM39 9H9v14h4v-9h22v9h4V9zm-8 9H17v5h14v-5z"/></svg>
</template>
<script>

export default {
  name: 'IconBed',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
